import { FaTrashAlt } from "react-icons/fa";
import Container from "./VariationProductsListStyle";

export default function VariationProductsGroupsList({ productId, variationId, history, variationGroups, disabled, onClickDeleteVariationGroup }) {

  function GoToGroup(groupId: number) {
    history.push(`/products/${productId}/${variationId}/${groupId}`);
  }

  console.log(variationGroups);
  return (
    <Container id="productVariationsTable" className="panel">
      <section id="title">
        <h4>Grupos da variação</h4>
        <button
          className="btn btn-success"
          disabled={disabled}
          onClick={e => GoToGroup(0)}>Adicionar
        </button>
      </section>
      <table className="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th scope="col">Grupo</th>
            <th scope="col">Material</th>
            <th scope="col">Cor</th>
            <th scope="col">Deletar</th>
          </tr>
        </thead>
        <tbody>
          {variationGroups && variationGroups.length > 0 && variationGroups.map(variationGroup => {
            return (
              <tr className="clickable" key={variationGroup.id}>
                <td onClick={e => GoToGroup(variationGroup.id)}>{variationGroup.name}</td>
                <td className="max-size-td" onClick={e => GoToGroup(variationGroup.id)}>{variationGroup.materialUrl}</td>
                <td onClick={e => GoToGroup(variationGroup.id)}><input
                  type="color"
                  defaultValue={variationGroup.color === "" ? "#000000" : variationGroup.color}
                  disabled={true}
                /></td>
                <td className="action">
                  <button
                    onClick={() => onClickDeleteVariationGroup(variationGroup)}
                    disabled={disabled}
                  ><FaTrashAlt className="icon" /></button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Container>

  );
}